const Backbone = require('backbone');
const Produtos = require('./produtos');

var Collection = new Backbone.Collection();


var update = function() {
	var produtos = Produtos.toJSON();

	var filtros = [];
	produtos.forEach(function(produto) {
		produto.filtros.forEach(function(filtro){
			filtro.ativo = 0;
			filtros.push(filtro);
		});
	});
	var collection = new Backbone.Collection(filtros);
	filtros = collection.toJSON();
	Collection.set(filtros);
};

Produtos.on('update', update);
update();

module.exports = Collection;


//////////////////
// WEBPACK FOOTER
// ./collections/filtros.js
// module id = 49
// module chunks = 0